import { useState, useEffect } from "react";

import {
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel
} from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import Loading from "../../../Loading";

import "./styles.css";

const QuestionCreatorBottomMenu = props => {
  const [loading, setLoading] = useState(false);
  const [difficulties, setDifficulties] = useState([]);
  const [currDifficulty, setCurrDifficulty] = useState(
    props.difficultyLevel || 1
  );
  const [segments, setSegments] = useState([]);
  const [currSegment, setCurrSegment] = useState(props.segment || null); // id (number)
  const [disciplines, setDisciplines] = useState([]);
  const [currDiscipline, setCurrDiscipline] = useState(
    props.discipline || null
  ); // id (number)
  const [abilities, setAbilities] = useState([]);
  const [currAbility, setCurrAbility] = useState(props.ability || null); // id (number)
  const [modules, setModules] = useState([]);
  const [currModule, setCurrModule] = useState(props.module || null); // id (number)

  // sync if parent props change (ex: carregou a questão para edição)
  useEffect(() => {
    setCurrDiscipline(props.discipline || null);
    setCurrSegment(props.segment || null);
    setCurrModule(props.module || null);
    setCurrAbility(props.ability || null);
  }, [props.discipline, props.segment, props.module, props.ability]);

  useEffect(() => {
    pullInitialData();
    // se já tiver disciplina (id) quando montar, busca segmentos
    if (currDiscipline) getSegments(currDiscipline);
    if (currSegment) pullModulesAbilities(currSegment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pullInitialData = async () => {
    setLoading(true);
    try {
      const disciplinesResponse = await axios.get(
        `${URL.api}classification/discipline/list`,
        { headers: { authorization: `Bearer ${props.user.token}` } }
      );

      const difficultiesResponse = await axios.get(
        `${URL.api}classification/difficulty_level/list`,
        { headers: { authorization: `Bearer ${props.user.token}` } }
      );

      // disciplinas vem como [{id, name}, ...]
      setDisciplines(disciplinesResponse.data.data || []);
      setDifficulties(difficultiesResponse.data.data || []);
    } catch (err) {
      console.error("Erro ao carregar dados iniciais:", err.message);
    } finally {
      setLoading(false);
    }
  };

  // segmentID pode ser objeto ou id; disciplina também pode ser id
  const pullModulesAbilities = async segmentID => {
    const segId = segmentID?.id || segmentID;
    const disciplineId = currDiscipline?.id || currDiscipline;
    if (!segId || !disciplineId) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${URL.api}classification/ability/moduleAbilityByDiscipline/${disciplineId}/${segId}`,
        { headers: { authorization: `Bearer ${props.user.token}` } }
      );

      const modulesData = response.data.data?.modules || [];
      const abilitiesData = response.data.data?.abilities || [];

      setModules(
        modulesData
          .map(m => ({
            value: m.id,
            label: m.description,
            objective: m.objective
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );

      setAbilities(
        abilitiesData.map(a => ({
          value: a.id,
          label: `${a.code} - ${a.description}`,
          code: a.code,
          objective: a.objective
        }))
      );
    } catch (err) {
      console.error("Erro ao carregar módulos e habilidades:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const getSegments = async DisciplineId => {
    const disciplineId = DisciplineId?.id || DisciplineId;
    if (!disciplineId) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${URL.api}evaluation/question/getFilterStructure`,
        {
          params: { discipline: disciplineId, mine: false },
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );

      setSegments(
        (response.data?.data || []).map(segment => ({
          id: segment.segment_id,
          name: segment.segment_name
        }))
      );
    } catch (err) {
      console.error("Erro ao carregar segmentos:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const changeSegment = segmentId => {
    props.moduleChanger(null, null);
    props.abilityChanger(null, null);
    props.segmentChanger(segmentId);
    setCurrAbility(null);
    setCurrModule(null);
  };

  const changeDiscipline = e => {
    // e pode ser objeto (react-select) ou id
    const disciplineId = e?.id || e?.value || e;
    props.moduleChanger(null, null);
    props.abilityChanger(null, null);
    props.disciplineChanger(Number(disciplineId));
    setCurrAbility(null);
    setSegments([]);
    setCurrSegment(null);
    setCurrModule(null);
  };

  return (
    <>
      {props.moreInfo && (
        <div className="w-100 position-relative">
          <div className="w-100">
            {/* Dificuldade */}
            <div className="w-100 row m-0">
              <div className="col-4 p-0 mr-4">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">Dificuldade</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione uma dificuldade"
                      className="basic-single flex-1"
                      classNamePrefix="select"
                      options={difficulties}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.id}
                      value={difficulties.find(
                        item => item.id === currDifficulty
                      )}
                      onChange={e => {
                        props.difficultyChanger(Number(e.id));
                        setCurrDifficulty(Number(e.id));
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>
              <div className="col p-0">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">Tipo de Questão</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione um tipo"
                      className="basic-single flex-1"
                      classNamePrefix="select"
                      options={props.itemTypes}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.id}
                      value={props.itemTypes.find(
                        item => item.id === props.currentTypeId
                      )}
                      onChange={e => {
                        props.typeChanger(Number(e.id));
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>
            </div>

            {/* Componente Curricular */}
            <div className="w-100 row m-0">
              <div className="col p-0">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">
                    Componente Curricular
                  </CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione um componente curricular"
                      className="basic-single flex-1"
                      classNamePrefix="select"
                      options={disciplines}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.id}
                      value={
                        disciplines.find(item => item.id === currDiscipline) ||
                        null
                      }
                      onChange={e => {
                        changeSegment(null);
                        changeDiscipline(e);
                        setCurrDiscipline(Number(e.id));
                        if (e) getSegments(e.id);
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>
            </div>

            {/* Segmento, Módulo e Habilidade */}
            <div className="w-100 row m-0">
              <div className="col-4 p-0 mr-4">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">Segmento</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione um segmento"
                      className="basic-single flex-1"
                      classNamePrefix="select"
                      name="Segmento"
                      options={segments}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.id}
                      value={
                        segments.find(item => item.id === currSegment) || null
                      }
                      noOptionsMessage={() =>
                        "Selecione um componente curricular"
                      }
                      onChange={async e => {
                        const id = e?.id || e;
                        changeSegment(Number(id));
                        setCurrSegment(Number(id));
                        setCurrModule(null);
                        props.moduleChanger(null, null);
                        setCurrAbility(null);
                        props.abilityChanger(null, null);
                        if (e) await pullModulesAbilities(e.id);
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>

              <div className="col p-0 mr-4">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">Módulo</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione um módulo"
                      name="Módulo"
                      options={modules}
                      value={modules.find(m => m.value === currModule) || null}
                      className="basic-single flex-1"
                      classNamePrefix="select"
                      noOptionsMessage={() =>
                        "Selecione um segmento e um componente curricular"
                      }
                      onChange={e => {
                        setCurrModule(Number(e.value));
                        props.moduleChanger(Number(e.value), e.objective);
                        setCurrAbility(null);
                        props.abilityChanger(null, null);
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>

              <div className="col p-0">
                <CFormGroup>
                  <CLabel className="text-muted mb-1">Habilidade</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Select
                      placeholder="Selecione uma habilidade"
                      name="Habilidade"
                      options={abilities}
                      value={
                        abilities.find(a => a.value === currAbility) || null
                      }
                      className="basic-multi-select flex-1"
                      classNamePrefix="select"
                      noOptionsMessage={() =>
                        "Selecione um segmento e um componente curricular"
                      }
                      onChange={e => {
                        setCurrAbility(Number(e.value));
                        props.abilityChanger(Number(e.value), e.objective);
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionCreatorBottomMenu);
